// extracted by mini-css-extract-plugin
export default {"notFoundContentContainer":"NotFoundContent_notFoundContentContainer__r3qoW","notFoundContentImage":"NotFoundContent_notFoundContentImage__SP6i-"};